import React, { useState, useEffect } from 'react'
import Layout from '../../components/layout_micro'
import Header from './header'
import Stepper from './stepper'
import Container from '../../components/layout_micro/container'
import ResponsiveFonts from '../../components/layout_micro/responsiveFonts'
import Calendar from './calendar'
import GenerealInfo from './generalInfo'
import Info from './info'
import Faqs from './faqs'
import Footer from '../../components/footer'
import useOperations from './useOperations'
import useApointmentCalculator from './useApointmentCalculator'
import OutForm from './outForm'
import { useParams } from 'react-router-dom'
import { CircularProgress, Grid } from '@material-ui/core'
import Paying from './paying'
import Send from './sendData'
import Indications from './indications'
import { sendMail } from '../../../modules/appointment'
import { getStringHourFormat12, toString } from '../../../helpers/date'

const Appointment = props => {
  var { currentid } = useParams()

  // const initialStates
  const initialCurrentStep = currentid ? 4 : 1
  const initialIdApointment = currentid || null

  // initialize states
  const [currentStep, setCurrentStep] = useState(initialCurrentStep)
  const [idAppointment, setIdAppointment] = useState(initialIdApointment)

  // handlers
  const { handleSave, handleUpdate, data } = useOperations(currentid || (idAppointment || null))
  const { interval, init, end, saturdayEnd, saturdayInit } = useApointmentCalculator(data ? data.date : null)

  const handleConfirmCalendar = async date => {
    setCurrentStep(2)
    if (!idAppointment) {
      const id = await handleSave({ date, duration: interval })
      setIdAppointment(id)
    } else await handleUpdate(idAppointment, { date })
  }

  const handleConfirmGeneralData = (data) => {
    handleUpdate(idAppointment, data)
    setCurrentStep(data.isExternalFormComplete ? 4 : 3)
  }

  // set isExternalFormComplete === true whet came step 4
  useEffect(() => {
    if (currentStep === 4 && data && !data.isExternalFormComplete) {
      handleUpdate(idAppointment, { isExternalFormComplete: true })
    }
  }, [currentStep, data])

  const handleAprove = () => {
    setCurrentStep(5)
    handleUpdate(idAppointment, { isPaid: true, isFinished: true })
    sendMail({ name: `${data.name} ${data.plastname} ${data.mlastname}`, email: data.email, birtdate: data.birtdate, phone: data.phone, date: `${toString(data.date)} a las ${getStringHourFormat12(data.date)}` })
  }

  // setCurrentSStep === 5 whet status is isFinished === true
  useEffect(() => {
    if (data && data.isFinished === true && currentStep !== 5) {
      setCurrentStep(5)
    }
  }, [data])

  const handleFinish = () => {
    setCurrentStep(step => step + 1)
    handleUpdate(idAppointment, { isFinished: true })
    sendMail({ name: `${data.name} ${data.plastname} ${data.mlastname}`, email: data.email, birtdate: data.birtdate, phone: data.phone, date: `${toString(data.date)} a las ${getStringHourFormat12(data.date)}` })
  }

  // scroll intoView
  useEffect(() => {
    try {
      document.getElementById('intoView').scrollIntoView()
    } catch (error) {
      console.log('error')
    }
  }, [currentStep])

  if (!data && !!currentid) {
    return (
      <Grid container alignItems='center' justify='center' style={{ minHeight: '90vh' }}>
        <CircularProgress color='primary' />
      </Grid>
    )
  }

  return (
    <Layout>
      <Header />
      <Container id='intoView'>
        <ResponsiveFonts>
          <Stepper currentStep={currentStep} onChange={() => {}} />
          {currentStep === 1 && (
            <Calendar
              value={data ? data.date : null}
              onConfirm={handleConfirmCalendar}
              interval={interval}
              init={init}
              end={end}
              saturdayEnd={saturdayEnd}
              saturdayInit={saturdayInit}
            />
          )}
          {currentStep === 2 && (
            <GenerealInfo
              initialState={data}
              onConfirm={handleConfirmGeneralData}
              onBack={event => setCurrentStep(step => step - 1)}
            />
          )}
          {currentStep === 3 && (
            <OutForm
              id={idAppointment}
              onBack={event => setCurrentStep(currentStep - 1)}
            />
          )}
          {currentStep === 4 && (
            <Paying
              onConfirm={handleFinish}
              methodPay={data.methodPay}
              onBack={e => setCurrentStep(step => step - 2)}
              onApprove={handleAprove}
            />
          )}
          {currentStep === 5 && (
            <Send
              id={data._id}
              isPaid={data.isPaid}
              email={data.email}
              date={data.date}
              name={`${data.name} ${data.plastname} ${data.mlastname}`}
            />
          )}
        </ResponsiveFonts>
      </Container>
      <ResponsiveFonts>
        <Indications />
        <Info />
        <Faqs />
      </ResponsiveFonts>
      <Footer disableNotifications />
    </Layout>
  )
}

export default Appointment
